import React from 'react'

import { Campaign } from '@/core/api/entities/campaign/campaign'
import { Group } from '@/core/api/entities/group'
import { useTranslation } from '@/core/i18n/useTranslation'
import ConfirmationModal from '@/shared/components/molecules/ConfirmationModal/ConfirmationModal'

interface RemoveCampaignFromGroupModalProps {
	visible: boolean
	campaign: Campaign | null
	group: Group | null
	onClose: () => void
	onConfirm: () => void
	isRemoving: boolean
}

const RemoveCampaignFromGroupModal: React.FC<
	RemoveCampaignFromGroupModalProps
> = ({ visible, campaign, group, onClose, onConfirm, isRemoving }) => {
	const { t } = useTranslation('common')

	return (
		<ConfirmationModal
			visible={visible}
			title={t('entities.group.remove_campaign.title')}
			description={t('entities.group.remove_campaign.description', {
				campaignName: campaign?.name,
				groupName: group?.name,
			})}
			confirmText={t('entities.group.remove_campaign.confirm')}
			cancelText={t('actions.cancel')}
			variant="destructive"
			onConfirm={onConfirm}
			onClose={onClose}
			isLoading={isRemoving}
			loadingText={t('actions.loading')}
		/>
	)
}

export default RemoveCampaignFromGroupModal
